import { observer } from "mobx-react";
import { h } from "preact";
import { Suspense, lazy } from "preact/compat";
import { useMemo } from "preact/hooks";
import { translate, t } from "restaumatic-client";
import CrossSellingItem from "./CrossSellingItem";
import CrossSellingBarItem from "./CrossSellingBarItem";
// TODO: Extract the Slider component if it will be used in more places
function CrossSellingList(props) {
    const { fieldId, items, openProductCard, variant = "cards" } = props;
    const isSmallMin = useMemo(() => {
        var _a;
        return (_a = Skubacz.Device.screen.isSmallMin()) !== null && _a !== void 0 ? _a : false;
    }, []);
    // Lazy load Splide slider component with library for desktop (~35kB JS)
    if (variant === "cards" && isSmallMin) {
        const CrossSellingListSlider = lazy(() => import("./CrossSellingListSlider"));
        return (h(Suspense, { fallback: undefined },
            h(CrossSellingListSlider, { fieldId: fieldId, items: items, openProductCard: openProductCard })));
    }
    if (variant === "bars") {
        return (h(BarList, { fieldId: fieldId, items: items, openProductCard: openProductCard }));
    }
    return (h(CardList, { fieldId: fieldId, items: items, openProductCard: openProductCard }));
}
const CardList = observer((props) => {
    const { fieldId, items, openProductCard } = props;
    return (h("fieldset", { "data-field-id": fieldId, class: "m-form__group m-form__group--spacing-top" },
        h("div", { class: "m-crossup m-crossup--redesigned m-crossup--with-title" },
            h("div", { class: "row" },
                h("div", { class: "col-md-12" },
                    h("div", { class: "m-crossup__header" },
                        h("h3", { class: "m-crossup__title h4" }, translate(t.crossup.title))))),
            h("div", { class: "row" },
                h("div", { class: "col-md-12" },
                    h("div", { class: "m-crossup__body" },
                        h("div", { class: "m-crossup__list" }, items.map((item) => (h(CrossSellingItem, { item: item, key: item.id, openProductCard: openProductCard }))))))))));
});
const BarList = observer((props) => {
    const { fieldId, items, openProductCard } = props;
    // We are testing this view with limitted number of items
    const limittedItems = items.slice(0, 3);
    return (h("div", { class: "m-crossup m-crossup--bars", "data-field-id": fieldId },
        h("h3", { class: "m-crossup__bar-title h5" }, "Cz\u0119sto kupowane razem"),
        h("div", { class: "m-crossup__bar-list" }, limittedItems.map((item) => (h(CrossSellingBarItem, { key: item.id, title: item.name, price: item.price, onNameClick: openProductCard !== undefined
                ? () => openProductCard(item.productInstance)
                : undefined, onCtaClick: () => item.behaviour.type === "Cart"
                ? item.behaviour.add()
                : undefined }))))));
});
export default observer(CrossSellingList);
